import React from "react";

import SocialLinks from './SocialLinks';

function Footer() {
    return (
        <footer className="tb-footer">
            <SocialLinks className="tb-footer-links" />
        </footer>
    );
}

export default Footer;